<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_MY_NETWORKS"
    title="My Networks"
    :breadcrumbs="breadcrumbs"
    page-name="My Networks"
    align="center"
    width="full"
    action-button-text="Create New Network"
    @click:action="submitOpenNetworkModal"
  >
    <SmartFeed
      :source="useMyNetworkFeedStore"
      load-more-behavior="auto"
      :show-filters="false"
    />
    <NetworkModal />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { SECTION_COMMUNITY, PAGE_MY_NETWORKS } from "@/constants/nav-constants";
import NetworkModal from "@/components/networks/NetworkModal.vue";
import { mapActions } from "pinia";
import { useNetworkStore } from "@/stores/network-store";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { useMyNetworkFeedStore } from "@/smart-feed/stores/feed/my-network-feed-store";

export default {
  name: "MyNetworks",
  components: {
    SmartFeed,
    NetworkModal,
    PageWrapper,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_MY_NETWORKS,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
      ];
    },
  },
  methods: {
    useMyNetworkFeedStore,
    ...mapActions(useNetworkStore, ["openNetworkModal"]),
    submitOpenNetworkModal() {
      this.openNetworkModal();
    },
  },
};
</script>
